// extracted by mini-css-extract-plugin
export default {"elementContainer":"ViewerColumnSection_elementContainer__YUlub","container":"ViewerColumnSection_container__zygWd"};